'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FacebookShare = function (_React$Component) {
	(0, _inherits3.default)(FacebookShare, _React$Component);

	function FacebookShare(props) {
		(0, _classCallCheck3.default)(this, FacebookShare);

		var _this = (0, _possibleConstructorReturn3.default)(this, (FacebookShare.__proto__ || Object.getPrototypeOf(FacebookShare)).call(this, props));

		_this.state = {
			link: props.link
		};
		return _this;
	}

	(0, _createClass3.default)(FacebookShare, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (!this.state.link) {
				this.setState({
					link: document.location.href
				});
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps) {
			if (this.props.link !== prevProps.link) {
				this.setState({
					link: this.props.link
				});
			}
		}
	}, {
		key: 'render',
		value: function render() {
			return this.props.children('https://www.facebook.com/sharer.php?u=' + encodeURIComponent(this.state.link));
		}
	}]);
	return FacebookShare;
}(_react2.default.Component);

exports.default = FacebookShare;
//# sourceMappingURL=index.js.map